import classNames from 'classnames';
import React from 'react';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { ShowMoreWrapper } from '../ReadMore/ShowMoreWrapper';
import TWSubscriptionPlan, { TWSubscriptionPlanCardType } from '../TWSubscriptionPlan';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var SubscriptionPlanListPage;

(function (SubscriptionPlanListPage) {
  SubscriptionPlanListPage["POSTS"] = "posts";
  SubscriptionPlanListPage["SERVICE_PROFILE"] = "serviceProfile";
})(SubscriptionPlanListPage || (SubscriptionPlanListPage = {}));

/**
 * Primary UI component for user interaction
 */
export var TWSubscriptionPlanList = function TWSubscriptionPlanList(_ref) {
  var plans = _ref.plans,
      onPlanSelect = _ref.onPlanSelect,
      page = _ref.page,
      planWaitlistIds = _ref.planWaitlistIds;
  var deviceInfo = useDeviceInfo(); // card isn't responsive because 1st card is full width & subsequent cards are not, but only for desktop

  var activePlans = plans.filter(function (_ref2) {
    var active = _ref2.active,
        waitlist = _ref2.waitlist,
        visiblePlans = _ref2["public"];
    return visiblePlans && (active || waitlist);
  }).sort(function (a, b) {
    return a.price_cents - b.price_cents;
  }); // show fewer cards depending on device: https://www.figma.com/file/hFo1cSdUfVmbeDBkmNaR79?embed_host=notion&kind=&node-id=8768%3A0&viewer=1

  var numberToShow = deviceInfo.mobile ? 1 : deviceInfo.tablet || page === SubscriptionPlanListPage.POSTS ? 2 : 3;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: activePlans.length > 0 ? /*#__PURE__*/_jsx(ShowMoreWrapper, {
      numberToShow: numberToShow,
      rootClassName: classNames('grid grid-cols-1 gap-x-6 gap-y-8', {
        'md:grid-cols-2': page === SubscriptionPlanListPage.POSTS && activePlans.length > 1 || page !== SubscriptionPlanListPage.POSTS,
        'lg:grid-cols-3': page !== SubscriptionPlanListPage.POSTS,
        'md:max-w-sm md:mx-auto': page === SubscriptionPlanListPage.POSTS && activePlans.length === 1
      }),
      buttonClassName: "flex justify-center mx-auto mt-5",
      showMoreLabel: "View more",
      showLessLabel: "View fewer",
      showButton: true,
      children: activePlans.map(function (plan) {
        var type = TWSubscriptionPlanCardType.SKINNY;
        if (!deviceInfo.mobile && activePlans.length === 1 && page !== SubscriptionPlanListPage.POSTS) type = TWSubscriptionPlanCardType.FULL_WIDTH;
        return /*#__PURE__*/_jsx("div", {
          className: classNames('', {
            'md:col-span-3': type === TWSubscriptionPlanCardType.FULL_WIDTH
          }),
          children: /*#__PURE__*/_jsx(TWSubscriptionPlan, {
            plan: plan,
            onSelect: onPlanSelect,
            type: type,
            planWaitlistIds: planWaitlistIds
          })
        }, plan.id);
      })
    }) : null
  });
};